var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ranges" }, [
    _vm.ranges
      ? _c(
          "ul",
          _vm._l(_vm.ranges, function(value, key) {
            return _c(
              "li",
              {
                key: key,
                class: _vm.range_class(value),
                attrs: { "data-range-key": key },
                on: {
                  click: function($event) {
                    _vm.$emit("clickRange", value)
                  }
                }
              },
              [_vm._v(_vm._s(key) + "\n        ")]
            )
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05a51dc9", { render: render, staticRenderFns: staticRenderFns })
  }
}